import Attachment from '@/types/Attachment'

type OnlyAttachmentKeys<T> = {
  [K in keyof T]: T[K] extends Attachment | Attachment[] | undefined ? K : never
}[keyof T];

// Appending files lists from file input to the form data when sending a request to backend
declare global {
  interface FormData {
    appendFileList<T extends object>(
      fileList: FileList | undefined,
      objectName: string,
      fieldName: OnlyAttachmentKeys<T>,
    ): void
  }
}

export function fileListToFormData<T extends object>(
  fileList: FileList | undefined,
  formData: FormData,
  objectName: string,
  fieldName: OnlyAttachmentKeys<T>,
) {
  if (!fileList?.length) return

  const key = String(fieldName)

  Array.from(fileList).forEach((file, idx) => {
    formData.append(`${objectName}[${key}][${idx}]`, file)
  })
}

FormData.prototype.appendFileList = function(fileList, objectName, fieldName) {
  fileListToFormData(fileList, this, objectName, fieldName)
}
